import {NextBannersConfig, NextBannerConfig} from '../models/next-banners-config';
import {SalesChannel} from '../consts/sales-channel.enum';
import {StepKey} from '../enums/step-key.enum';

const DEFAULT_BANNER: NextBannerConfig = {
    title: 'NEXT_BANNER.TITLE',
    subtitle: 'NEXT_BANNER.SUBTITLE',
    imageSrc: './assets/images/banner-car.webp'
};

const NESTBANK_BANNER: NextBannerConfig = {
    title: 'NEXT_BANNER.NESTBANK.TITLE',
    subtitle: 'NEXT_BANNER.NESTBANK.SUBTITLE',
    imageSrc: './assets/images/banner-nestbank.svg'
}

export const NEXT_BANNERS_CONFIG: NextBannersConfig[] = [
    {
        salesChannel: SalesChannel.KIOSKPOLIS,
        bannerSteps: [
            {
                stepKey: StepKey.FIRST_STEP_0,
                banner: DEFAULT_BANNER
            },
            {
                stepKey: StepKey.FIRST_STEP_1,
                banner: DEFAULT_BANNER
            },
            {
                stepKey: StepKey.FIRST_STEP_2,
                banner: DEFAULT_BANNER
            },
            {
                stepKey: StepKey.FIRST_STEP_3,
                banner: DEFAULT_BANNER
            },
            {
                stepKey: StepKey.THIRD_STEP,
                banner: DEFAULT_BANNER
            }
        ]
    },
    {
        salesChannel: SalesChannel.NESTBANK,
        bannerSteps: [
            {
                stepKey: StepKey.FIRST_STEP_0,
                banner: NESTBANK_BANNER
            },
            {
                stepKey: StepKey.FIRST_STEP_1,
                banner: NESTBANK_BANNER
            },
            {
                stepKey: StepKey.FIRST_STEP_2,
                banner: NESTBANK_BANNER
            },
            {
                stepKey: StepKey.FIRST_STEP_3,
                banner: NESTBANK_BANNER
            },
            {
                stepKey: StepKey.THIRD_STEP,
                banner: NESTBANK_BANNER
            }
        ]
    }
];
